import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import EditEmailTemplateToolbar from "./EditEmailTemplateToolbar";
import ErrorAlert from "../../components/ErrorAlert";
import AceEditorDefaultValue from "../../components/AceEditorDefaultValue";
import Icon from "../../components/Icon";

import { fetchEmailTemplate, emailTemplateSetKeyValue } from "../../actions";

export class EditEmailTemplatePage extends Component {
  componentWillMount() {
    const { id } = this.props.match.params;
    const { accountId } = this.props.match.params;
    this.props.fetchEmailTemplate(accountId, id);
    this.onHtmlChange = this.onHtmlChange.bind(this);
    this.onCssChange = this.onCssChange.bind(this);
    this.onDataChange = this.onDataChange.bind(this);
  }

  onHtmlChange(newValue) {
    this.props.emailTemplateSetKeyValue("template", newValue);
  }

  onCssChange(newValue) {
    this.props.emailTemplateSetKeyValue("style", newValue);
  }

  onDataChange(newValue) {
    try {
      const data = JSON.parse(newValue);
      this.props.emailTemplateSetKeyValue("fields", data);
    } catch (e) { }
  }

  render() {
    const { emailTemplate, showHtml, showData } = this.props;
    const { accountId } = this.props.match.params;

    const numColumns = (showHtml ? 1 : 0) + (showData ? 1 : 0);

    const columnWidth = 100 / numColumns + "%";

    if (emailTemplate.failed) {
      return (
        <ErrorAlert title="404">
          <Link to={`/clients/${accountId}/email-templates`}>
            Return to list
          </Link>
        </ErrorAlert>
      );
    }

    if (!emailTemplate.id) {
      return <div />;
    }

    return (
      <div>
        <Helmet>
          <title>{`Mercury - ${emailTemplate.name}`}</title>
        </Helmet>
        <EditEmailTemplateToolbar accountId={accountId} />
        <div
          style={{
            position: "fixed",
            top: 97,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
          }}
        >
          {showHtml && (
            <div style={{ width: columnWidth, height: "100%" }}>
              <AceEditorDefaultValue
                key={`${showHtml}${showData}`}
                mode="handlebars"
                theme="monokai"
                onChange={this.onHtmlChange}
                name="module_template"
                width="100%"
                height="100%"
                editorProps={{ $blockScrolling: true }}
                defaultValue={emailTemplate.template}
              />
            </div>
          )}
          {showData && (
            <div style={{ width: columnWidth, height: "100%" }}>
              <AceEditorDefaultValue
                key={`${showData}${showHtml}`}
                mode="json"
                theme="monokai"
                onChange={this.onDataChange}
                name="module_data"
                width="100%"
                height="100%"
                editorProps={{ $blockScrolling: true }}
                defaultValue={JSON.stringify(
                  emailTemplate.fields || [],
                  null,
                  4
                )}
              />
            </div>
          )}
          {numColumns === 0 && (
            <div
              style={{
                width: "100%",
                height: "100%",
                background: "#333",
                color: "#444",
                fontSize: 300,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Icon icon="bolt" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

EditEmailTemplatePage.propTypes = {
  fetchEmailTemplate: PropTypes.func.isRequired,
  emailTemplateSetKeyValue: PropTypes.func.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { emailTemplate, showHtml, showData } = state.emailTemplateEditor;
  return {
    emailTemplate,
    showHtml,
    showData,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  fetchEmailTemplate,
  emailTemplateSetKeyValue,
})(EditEmailTemplatePage);
